export const classNames = (
  ...classes: (string | undefined | false | null | (string | undefined | false | null)[])[]
): string => {
  return classes.flat(Infinity).filter(Boolean).join(' ');
};
